 

export default {
  grades:[],
  home:'',
  search: []
}
